  <!-- Page Conttent -->
  <main class="page-content">
    <div class="page-template-comming-soon bg_color--3">
        <div class="site">
            <div class="row">
                <div class="col-lg-4 col-xl-6 bg_image--58 order-2 order-lg-1 d-none d-md-block fullscreen">

                </div>
                <div class="col-lg-8 col-xl-6 fullscreen order-1 order-lg-2 d-flex align-items-center">
                    <div class="maintanence-wrapper comming-soon-wrapper plr--95">
                        <div class="inner">
                            <div class="logo">
                               
                            </div>
                            <div class="content mt--95 mt_lg--30 mt_md--30 mt_sm--30">
                                <h3 class="heading heading-h3 text-white">Algo genial se está creando.</h3>
                                <div class="box-timer countdown-style-1 bg-solid-grey mt--95 mt_lg--30 mt_md--30 mt_sm--30">
                                    <div class="countbox timer-grid">
                                        <div data-countdown="2021/03/15"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="maintanence-form mt--75 mt_lg--30 mt_md--30 mt_sm--30">
                                <input type="text" placeholder="Tu e-mail">
                                <button>Registrarme</button>
                            </div>
                            <div class="form-desc">Entérate de cada uno de nuestros eventos.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Social Networks -->
            <div class="maintenance-social-networks">
                <div class="inner">
                    <a href="#"><span class="social-text">Facebook</span></a>
                    <a href="#"><span class="social-text">Twitter</span></a>
                    <a href="#"><span class="social-text">Instagram</span></a>
                </div>
            </div>
        </div>
    </div>
</main>
<!--// Page Conttent -->

